import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import theme, {
  StylableComponent,
  stylePropType,
} from '@adsk/alloy-react-theme';

type HeaderProps = StylableComponent<HTMLDivElement> & {
  left: ReactNode;
  right: ReactNode;
};

const Header: FC<HeaderProps> = ({
  className,
  style,
  children,
  left,
  right,
}) => {
  return (
    <div
      className={className}
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px',
          width: '100%',
          height: '48px',
          borderBottom: `1px solid ${theme.colors.charcoal200}`,
        },
        style,
      ]}
    >
      <div
        css={[
          {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            flex: 1,
          },
        ]}
      >
        {left}
      </div>

      {children}

      <div
        css={[
          {
            display: 'flex',
            alignItems: 'center',
          },
        ]}
      >
        {right}
      </div>
    </div>
  );
};

Header.displayName = 'Header';

Header.propTypes = {
  /** Button's content */
  children: PropTypes.node,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Header left side render function */
  left: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** Header right side render function */
  right: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default Header;
